import { Component, OnInit, ViewChild } from '@angular/core';
import { DataManager, WebApiAdaptor, Query} from '@syncfusion/ej2-data';
import { GridComponent, PageSettingsModel, SelectionSettingsModel, ToolbarItems } from '@syncfusion/ej2-angular-grids';
import { HttpErrorResponse } from '@angular/common/http';
import { ActivatedRoute, Router } from '@angular/router';
import { FormBuilder, FormGroup } from '@angular/forms';
import { DatePipe } from '@angular/common';

import { SharedFunctions } from '../../../../src/app/shared/shared.functions';

import { ServicioGastoService, MenuFuncionService, ServicioGrupoService } from '../../../../src/app/shared/services';
import { GridPageSettings, MenuFuncionCodes, ServicioGasto, SearchServicioGastoRequest, ServicioGrupo, SearchServicioGrupoRequest } from '../../../../src/app/shared/model';
import { ExportMediaTypeConstants } from '../../shared/model';

@Component({
  selector: 'app-servicioGastoLista',
  templateUrl: './servicioGastoLista.component.html'
})

export class ServicioGastoListaComponent implements OnInit {
  @ViewChild('grid')
  public grid: GridComponent;

  public data: DataManager;
  total: number = 0;
  searchForm: FormGroup;

  isValidating: boolean = false;
  isSearching: boolean = false;
  isExporting: boolean = false;
  // isCategoriaGastoSearching: boolean = false;
  isServicioGrupoSearching: boolean = false;
  canEdit: boolean = false;
  canAdd: boolean = false;
  canView: boolean = false;
  verSoloActivos: boolean = true;
  public query: Query;

  // categoriaGastoList: CategoriaGasto[];
  servicioGrupoList: ServicioGrupo[];

  public selectionOptions: SelectionSettingsModel;
  public pageSizes: number[];
  public toolbarOptions: ToolbarItems[];
  public pageSettings: PageSettingsModel;

  constructor(
    private formBuilder: FormBuilder,
    private sharedFunctions: SharedFunctions,
    private router: Router,
    private route: ActivatedRoute,
    private menuService: MenuFuncionService,
    // private categoriaGastoService: CategoriaGastoService,
    private servicioGrupoService: ServicioGrupoService,
    private service: ServicioGastoService,
    private datePipe: DatePipe) {

  }

  ngOnInit(): void {
    this.isValidating = true;
    this.menuService.checkMenuPadre(MenuFuncionCodes.SERVICIO_GASTO).subscribe(data => {
      this.isValidating = false;
      if (data != null && data.Success && data?.Result){
        this.canAdd = data.Result.some(x => x == MenuFuncionCodes.SERVICIO_GASTO_ADD);
        this.canView = data.Result.some(x => x == MenuFuncionCodes.SERVICIO_GASTO_LIST);
          if (this.canView){
            this.loadView();
          } else {
            this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
            this.router.navigate(['/']);
          }
      }
      else {
        this.sharedFunctions.showMessage("No tiene permisos para acceder a esta vista", "Error");
        this.router.navigate(['/']);
      }
    },
    (err: HttpErrorResponse) => {
      this.isValidating = false;
      this.sharedFunctions.handleError(err, true);
    });
  }

  loadView() {
    this.buildForm();

    this.pageSizes = GridPageSettings.PageSizeList;
    this.pageSettings = { pageCount: GridPageSettings.PageCount, pageSize: this.pageSizes[1], pageSizes: this.pageSizes };


    this.setQueryParams();

    this.data = new DataManager({
      url: this.service.getSearchUrl(),
      adaptor: new WebApiAdaptor(),
      headers: [this.service.getAuthorizationHeader(),this.service.getTenantHeader()]
    });

    // this.getCategoriasGastos();
    this.getGruposServicios();
  }

  buildForm() {
    this.searchForm = this.formBuilder.group({
      'Codigo': [null],
      'Nombre': [null],
      // 'CategoriaGastoId': [null],
      'ServicioGrupoId': [null]
    });
  }

  // getCategoriasGastos() {
  //   var r = new SearchCategoriaGastoRequest(null, null, true, "Nombre", null, null, true);
  //   this.isCategoriaGastoSearching = true;

  //   this.categoriaGastoService.search(r).subscribe(data => {
  //     this.isCategoriaGastoSearching = false;
  //     if (data != null)
  //       this.categoriaGastoList = data?.result;
  //   },
  //   (err: HttpErrorResponse) => {
  //     this.isCategoriaGastoSearching = false;
  //     this.sharedFunctions.handleError(err);
  //   });
  // }

  getGruposServicios() {
    var r = new SearchServicioGrupoRequest(null, null, true, "Nombre", null, null, true);
    this.isServicioGrupoSearching = true;

    this.servicioGrupoService.search(r).subscribe(data => {
      this.isServicioGrupoSearching = false;
      this.servicioGrupoList = data?.result;
    },
    (err: HttpErrorResponse) => {
      this.isServicioGrupoSearching = false;
      this.sharedFunctions.handleError(err);
    });
  }

  onGridActionFailure(event: any): void {
    this.sharedFunctions.showMessage("Ocurrió un error intentando realizar la búsqueda", "Error");
  }

  onSearch() {
    this.setQueryParams();
    this.grid.refresh();
  }

  setQueryParams() {
    if (this.query == null)
      this.query = new Query();

    var index = this.query.params.findIndex(obj => obj.key === "Codigo");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Codigo;
    else
      this.query.addParams("Codigo",this.searchForm.value.Tipo);

    index = this.query.params.findIndex(obj => obj.key === "Nombre");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.Nombre;
    else
      this.query.addParams("Nombre",this.searchForm.value.Nombre);

    // index = this.query.params.findIndex(obj => obj.key === "CategoriaGastoId");
    // if (index >= 0)
    //   this.query.params[index].value = this.searchForm.value.CategoriaGastoId;
    // else
    //   this.query.addParams("CategoriaGastoId",this.searchForm.value.CategoriaGastoId);

    index = this.query.params.findIndex(obj => obj.key === "ServicioGrupoId");
    if (index >= 0)
      this.query.params[index].value = this.searchForm.value.ServicioGrupoId;
    else
      this.query.addParams("ServicioGrupoId",this.searchForm.value.ServicioGrupoId);

    index = this.query.params.findIndex(obj => obj.key === "VerSoloActivos");
    if (index >= 0)
      this.query.params[index].value = this.verSoloActivos.toString();
    else
      this.query.addParams("VerSoloActivos",this.verSoloActivos.toString());
  }

  add() {
    if(this.canAdd){
      this.router.navigate(['servicio-gasto-edit', 0]);
    }else{
      this.sharedFunctions.showMessage("No tiene permisos para crear un nuevo item", "Error");
    }
  }

  edit(item: ServicioGasto) {
    if (!item || item.Id == null || item.Id <= 0) {
      this.sharedFunctions.showMessage("Debe seleccionar un item", "Error");
      return false;
    }

    this.router.navigate(['servicio-gasto-edit', item.Id]);
  }

  onExport() {
    var search = new SearchServicioGastoRequest(null, null, null, "", null, null, null, null, this.verSoloActivos);
    search = Object.assign(search, this.searchForm.value);

    this.isExporting = true;
    this.service.exportSearch(search).subscribe((data: Blob) => {
      this.isExporting = false;
      var fileUrl = URL.createObjectURL(data);

      var anchor = document.createElement("a");
      anchor.download = "ServiciosGastos_" + this.datePipe.transform(new Date(),"yyyy-MM-dd") + this.sharedFunctions.getFileExtension(ExportMediaTypeConstants.Csv);
      anchor.href = fileUrl;
      anchor.click();
    },
    (err: HttpErrorResponse) => {
      this.isExporting = false;
      this.sharedFunctions.handleError(err, true);
    })
  }
}
